import tag_green_icon from "../assets/icons/tag_green.svg";
import tag_red_icon from "../assets/icons/tag_red.svg";
import tag_yellow_icon from "../assets/icons/tag_yellow.svg";

export const StatusTagIcon = {
    "EXPIRED": tag_red_icon ,
    "ACTIVE": tag_green_icon,
    "UPCOMING": tag_yellow_icon
}